import React from 'react';
import { withLazyComponent } from './with-lazy-component';
import { ControlGroupSkeleton } from "../components/loading/control-group-skeleton";

const Component = React.lazy(() => import('../components/checkbox/checkbox-group-new'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component, ControlGroupSkeleton);

    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    config: {
      validators: ['choose:1'],
      stateType: 'array',
      defaultValue: null,
      defaultValueBehaviour: 'first',
      numberOfColumns: 1,
    },
  };
}
